(function () {
//import Human_Hidden from "./modules/human-hidden";
// import Captcha  from "./modules/captcha";
class $48f6e0a960fc886b$export$2e2bcd8739ae039 {
    constructor(){
        const captcha = jQuery('.elementor-field-type-sea_captcha'), refresh = jQuery(captcha).find('.sfo-captcha__refresh'), image = jQuery(captcha).find('.sfo-captcha__image'), form = jQuery(captcha).closest('form'), hidden = jQuery(captcha).find('input[name="sfo-captcha-crypt"]');
        this.$captcha = jQuery(captcha);
        this.$refresh = jQuery(refresh);
        this.$image = jQuery(image);
        this.$form = jQuery(form);
        this.$hidden = jQuery(hidden);
        this.url_captcha = sfo_variables && sfo_variables.sfo_url ? sfo_variables.sfo_url + '/captcha-image.php' : false;
        this.init();
    }
    init() {
        this.$refresh.on('click', this.refreshHandle.bind(this));
        this.$form.on('error', this.errorHandle.bind(this)); // on fail
        this.$form.on('reset', this.resetHandle.bind(this)); // on success
        if (this.$captcha.length > 1) console.log('== Sea Form Captcha only optimized for one field per page. ==');
    }
    errorHandle(e) {
        this.reset();
    }
    resetHandle(e) {
        this.reset();
    }
    refreshHandle(e) {
        this.refresh();
    }
    reset() {
        this.refresh();
        this.$form.find('.elementor-field-type-sea_captcha .elementor-field-textual').val('');
    }
    refresh() {
        let _this = this;
        jQuery.ajax({
            url: sfo_variables.ajaxurl,
            type: 'post',
            data: {
                action: 'captcha',
                nonce: sfo_variables.nonce
            },
            success: function(response) {
                const captcha = JSON.parse(response);
                _this.$image.attr('src', _this.url_captcha + '?crypt=' + captcha.crypturl);
                _this.$hidden.val(captcha.cryptMd5);
            }
        });
        return false;
    }
}


class $e99ac2ab34e8ebe0$export$2e2bcd8739ae039 {
    constructor(debug = false){
        const honeypot = jQuery('[data-id="sea_hp"]'), form = jQuery(honeypot).closest('form'), submit = jQuery(form).find('[type="submit"]'), container = jQuery(form).parent();
        this.$honeypot = jQuery(honeypot);
        this.$form = jQuery(form);
        this.$submit = jQuery(submit);
        this.$container = jQuery(container);
        this.init();
        if (debug) this.debug();
    }
    init() {
        // add event listener
        // 'submit_success' also elementor trigger
        this.$form.on('submit', this.submitHandle.bind(this));
        // on abort send
        this.$form.on('sea_form_abort_send', this.abortHandle.bind(this));
    }
    submitHandle(e) {
        this.validate(e);
    }
    validate(e) {
        let valid = this.$honeypot.val() !== '' ? false : true;
        if (!valid) this.abortSend(e);
    }
    abortSend(e) {
        // e.preventDefault();  // form is still being send by Elementor
        // don't fake success as user should see if it's not working
        //this.$form.remove();
        //this.addMessage();
        // needed to stop Elementor to send form anyway
        e.stopImmediatePropagation();
        this.$form.trigger('sea_form_abort_send');
        return false;
    }
    abortHandle(e) {
        this.reset();
    }
    addMessage() {
        this.$container.append('<div class="elementor-message elementor-message-success" role="alert">Hey Bot! The form was sent successfully.</div>');
    }
    reset() {
        this.$honeypot.val('');
    }
    debug() {
        // add button to start form send via script
        this.$container.append('<button class="sea-form-bot" style="margin-top: 2rem;">Pretend Bot</button>').on('click', this.debugHandle.bind(this));
    }
    /**
     * Light debugging
     * This is only to debug the things I needed so far..
     * - Fill in honeypot
     * - Fill out some textfields to check human interactio working
     * @param e
     */ debugHandle(e) {
        const element = e.target, textinputs = this.$form.find('input:not([type="hidden"]):not([data-id="sea_hp"]), select, textarea');
        if (jQuery(element).hasClass('sea-form-bot')) {
            // test human_check not being triggered
            jQuery(textinputs).each((i, textinput)=>{
                jQuery(textinput).val('debug textfield');
            });
            // test honeypot
            this.$honeypot.val('debug honeypot');
            // wait a little to be able to see what was filled in
            setTimeout(()=>{
                this.$form.submit();
            }, 2000);
        }
    }
}


class $8ba00ad7ceb27e26$export$2e2bcd8739ae039 {
    constructor(debug = false){
        const human = jQuery('[data-id="sea_human_check"]');
        if (human.length > 0) {
            const form = jQuery(human).closest('form'), submit = jQuery(form).find('[type="submit"]'), inputs = jQuery(form).find('input:not([type="hidden"]):not([data-id="sea_hp"]), select, textarea');
            this.$human = jQuery(human);
            this.$form = jQuery(form);
            this.$inputs = jQuery(inputs);
            this.$submit = jQuery(submit);
            this.isHuman = false;
            this.md5 = '';
            this.init();
        // uncomment all debugs if no honeypot field otherwise use honeypot debug
        // if(debug) {
        //     const container = jQuery(form).parent();
        //     this.$container   = jQuery(container);
        //     this.debug();
        // }
        }
    }
    init() {
        // >= add event listener =======================================
        // 'submit_success' also elementor trigger
        this.$form.on('submit', this.submitHandle.bind(this));
        // on success
        this.$form.on('reset', this.resetHandle.bind(this)); // elementor hook
        // 1) delay listening to blur event
        setTimeout(this.setBlurEvent.bind(this), 2000);
    //setTimeout(()=>{console.log( 'Listening to user interacton now' );}, 2000);
    // <= add event listener =======================================
    }
    setBlurEvent() {
        // 2) on human interaction create random string and add it to field
        // detect human interaction
        this.$inputs.each((i, input)=>{
            jQuery(input).on('blur', this.blurHandle.bind(this));
        });
    }
    /**
     * On human interaction
     * @param e
     */ blurHandle(e) {
        if (!this.isHuman) {
            this.md5 = this.randomString();
            this.$human.val(this.md5);
            this.isHuman = true;
        }
    }
    addHidden() {
        this.$form.prepend(`<input id="sfo-md5" type="hidden" name="md5" value="${this.md5}">`);
    }
    removeHidden() {
        jQuery('input#sfo-md5').remove();
    }
    submitHandle(e) {
        this.validate(e);
    }
    validate(e) {
        let valid = true;
        // 3) check if human interaction was detected
        if (!this.isHuman) valid = false;
        if (valid) // 4) check if random string is the right one
        valid = this.$human.val() !== this.md5 ? false : true;
        if (valid) // 5) add hidden field to check md5 in php
        this.addHidden();
    }
    resetHandle(e) {
        this.reset();
    }
    reset() {
        this.md5 = '';
        this.$human.val('');
        this.isHuman = false;
        this.removeHidden();
    }
    /**
     * Create a random string
     * @returns {string}
     */ randomString() {
        return (Math.random() + 1).toString(36).substring(2);
    }
}


'use strict';
(function($, w) {
    var $window = $(w);
    $window.on('elementor/frontend/init', function() {
        // ---------------------------------------
        // add spambot protection
        const debugSeaForm = false;
        new (0, $e99ac2ab34e8ebe0$export$2e2bcd8739ae039)(debugSeaForm);
        // ---------------------------------------
        // ---------------------------------------
        // add additional protection
        //new Human_Hidden(debugSeaForm);
        new (0, $8ba00ad7ceb27e26$export$2e2bcd8739ae039)(debugSeaForm);
        // ---------------------------------------
        // ---------------------------------------
        // add captcha
        new (0, $48f6e0a960fc886b$export$2e2bcd8739ae039)();
    // ---------------------------------------
    });
})(jQuery, window);

})();
//# sourceMappingURL=sea-form.js.map
